import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Tabs } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import PaymentCalculatorSectionTitle from '../shared/PaymentCalculatorSectionTitle';
import themeStyles from './PaymentFrequency.styles';
import { useAppSelector } from '../../../core/utils';
import { PaymentFrequency, selectPaymentFrequency } from '../../../core/reducers/financialCalculators';
const paymentTabs = [
    { key: PaymentFrequency.weekly, label: 'Shared.Common.PaymentFrequency.weekly' },
    { key: PaymentFrequency.biweekly, label: 'Shared.Common.PaymentFrequency.biWeekly' },
    { key: PaymentFrequency.monthly, label: 'Shared.Common.PaymentFrequency.monthly' },
];
const Wrapper = themeStyles.apply(Box, 'Wrapper');
const DEFAULT_ACTIVE_TAB = paymentTabs.findIndex(tab => tab.key === PaymentFrequency.weekly);
const getIndexByName = (name) => paymentTabs.findIndex(tab => tab.key === name) || 0;
const getNameByIndex = (index) => { var _a; return ((_a = paymentTabs[index]) === null || _a === void 0 ? void 0 : _a.key) || DEFAULT_ACTIVE_TAB; };
const PaymentFrequencyTabs = (_a) => {
    var _b;
    var { calculatorId, variant = (_b = Tabs === null || Tabs === void 0 ? void 0 : Tabs.variants) === null || _b === void 0 ? void 0 : _b.variantPrimary, disableAllFields, onChange, } = _a;
    const { t } = useTranslation();
    const paymentFrequency = useAppSelector(state => selectPaymentFrequency(state, calculatorId));
    const onChangeHandler = (index) => {
        if (onChange) {
            onChange(PaymentFrequency[getNameByIndex(index)]);
        }
    };
    const tabItems = paymentTabs.map(tab => ({
        key: tab.key,
        label: tab.label,
        content: tab.label,
    }));
    const renderTab = ({ key, label, index, isActive, ariaLabel }) => (_jsx(Tabs.Tab, { label: t(label), index: index, isActive: isActive, ariaLabel: ariaLabel, variant: variant, isDisabled: disableAllFields }, key));
    return (_jsxs(Wrapper, { "data-testid": "cy-bap-payment-frequency", children: [_jsx(PaymentCalculatorSectionTitle, { "data-testid": "cy-bap-payment-frequency-title", children: t('Pages.Bap.paymentFrequencyLabel') }), _jsx(Tabs, { value: getIndexByName(paymentFrequency), onChange: onChangeHandler, items: tabItems, renderTab: renderTab, ariaLabel: "payment-frequency", variant: variant, isDisabled: disableAllFields })] }));
};
export default PaymentFrequencyTabs;
